import React from "react"
export function LeftArrow(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M9.131 2L2.215 9.446a.821.821 0 00-.077 1.01l.077.098L9.131 18l1.106-1.108-5.67-6.106 13.43.02L18 9.21 4.586 9.19l5.65-6.082L9.132 2z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__left-arrow"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
